module.exports = __webpack_public_path__ + "img/contact_inner2-3.bd10b1b9.png";